import { useState, useEffect } from "react"

import { useDispatch, useSelector } from "react-redux";
import { useIntl } from "react-intl";

//Components
import { SidePanel, Button } from "@gpstrackit/react-controls";
import { Grid, Icon, IconButton } from "@mui/material"
import { Select } from "@gpstrackit/react-controls";

//Actions
import { getAccounts } from 'Modules/activities/views/main/redux/saga';
import { searchEntityRequest } from "Redux/actions";

import { HasPermission } from 'Core/security';
import { getStatusOptions } from 'Core/data/Helpers';

import CustomSelect from 'Components/Select';

const AdvancedFilters = (props) => {
    const { openPanel, setOpenPanel, tableRef, manufacturer, setAccount, account, setManufacturer, deviceModel, setDeviceModel, status, setStatus } = props;
    const { messages } = useIntl();
    const dispatch = useDispatch();

    //Redux States
    const manufacturers = useSelector(state => state.generalRedux.manufacturers);
    const loadingManufactuers = useSelector(state => state.generalRedux.manufacturersLoading);
    const deviceModels = useSelector(state => state.generalRedux.deviceModels);
    const loadingDeviceModels = useSelector(state => state.generalRedux.deviceModelsLoading);
    const loadingDevices = useSelector(state => state.commonRedux.loadingDataView);
    const user = useSelector(state => state.securityRedux.user);
    const { loadingAccounts } = useSelector(state => state.activitiesMainRedux.loadingAccounts)

    //Local States
    const [conditions, setConditions] = useState(tableRef?.current?.conditions || []);

    const handleApply = () => {
        tableRef?.current?.getData({ newConditions: tableRef?.current?.conditions });
    }

    const getAccountsForSelect = (input, callback) => {
        if (!input) {
            callback([])
            return
        }
        getAccounts(input).then((response) => {
            if (response.result) {
                const { items } = response?.result
                callback(items)
            }
        })
    }

    useEffect(() => {
        openPanel && (!manufacturers || manufacturers?.length === 0) && dispatch(searchEntityRequest({ key: "manufacturers" }));
        openPanel && (!deviceModels || deviceModels?.length === 0) && dispatch(searchEntityRequest({ key: "deviceModels" }));
        if (openPanel) setConditions(tableRef?.current?.conditions || [])
        else setConditions([])
    }, [openPanel]);

    return (
        <SidePanel
            isOpen={openPanel}
            toggle={() => setOpenPanel(!openPanel)}
            sidePanelButtonStyle={(manufacturer || deviceModel || status || account) ? "side-panel-button" : "side-panel-button-white"}
        >
            <Grid
                container
                direction='row'
                justifyContent='space-between'
                alignItems='center'
            >
                <Grid item xs={8}>
                    <label style={{ fontSize: 'large', fontWeight: 500 }}>{messages['accounts_main_advanced_filters']}</label>
                </Grid>
                <Grid item xs={4} style={{ display: 'flex', justifyContent: 'end' }}>
                    <IconButton
                        onClick={() => {
                            setManufacturer(null);
                            setDeviceModel(null);
                            setStatus(null);
                            setAccount(null)
                            let currentConditions = tableRef?.current?.conditions || conditions

                            let deleteManufacturer = currentConditions.findIndex((item) => item.fields && item.fields[0] === 'unit_deviceModel_manufacturerId');
                            deleteManufacturer >= 0 && currentConditions.splice(deleteManufacturer, 1);

                            let deleteAccount = currentConditions.findIndex((item) => item.fields && item.fields[0] === 'unit_companyId');
                            deleteAccount >= 0 && currentConditions.splice(deleteAccount, 1);

                            let deleteDeviceModel = currentConditions.findIndex((item) => item.fields && item.fields[0] === 'unit_deviceModel_id');
                            deleteDeviceModel >= 0 && currentConditions.splice(deleteDeviceModel, 1);

                            let deleteStatus = currentConditions.findIndex((item) => item.fields && item.fields[0] === 'unit_status');
                            deleteStatus >= 0 && currentConditions.splice(deleteStatus, 1);

                            tableRef?.current?.getData({ newConditions: currentConditions });
                            setConditions(currentConditions);
                        }}
                        size="large">
                        <Icon>delete</Icon>
                    </IconButton>
                </Grid>
                <Grid item xs={12} style={{ marginTop: 10, marginBottom: 10 }}>
                    <Button
                        className="btn btn-dark-blue btn-block"
                        onClick={(e) => {
                            e.preventDefault();
                            handleApply();
                        }}
                        disabled={loadingDevices}
                    >
                        {messages['devices_main_apply']}
                    </Button>
                </Grid>
                <Grid item xs={12} style={{ textAlign: 'left', marginTop: 10 }}>
                    <CustomSelect
                        async
                        value={account}
                        onChange={(item) => {
                            let currentConditions = conditions.length === 0 ? tableRef?.current?.conditions : conditions;
                            let newConditions = currentConditions.filter((item) => (item?.range && item?.timeFrame) || (item.fields && item.fields[0] !== 'unit_companyId'));
                            setAccount(item);
                            if (item) newConditions.push({ fields: ["unit_companyId"], terms: [item?.id], exact: true, conditionOperator: "AND" })
                            setConditions(newConditions);
                            tableRef?.current?.getData({ newConditions });
                        }}
                        label={messages['keyfobs_main_account']}
                        loadOptions={getAccountsForSelect}
                        loading={loadingAccounts}
                        getOptionLabel={e => e.name}
                        getOptionValue={e => e.id}
                    />
                </Grid>
                <Grid item xs={12} style={{ textAlign: 'left', marginTop: 10 }}>
                    {
                        HasPermission(user, "man") &&
                        <div>
                            <Select
                                id="manufactures"
                                label={messages['devices_main_manufacturer']}
                                value={manufacturers && manufacturers.length > 0 && manufacturers.find(x => x.id === +manufacturer)}
                                onChange={(manufacturer) => {

                                    setManufacturer(manufacturer ? manufacturer.id : null);
                                    setDeviceModel(null);
                                    let currentConditions = conditions.length === 0 ? tableRef?.current?.conditions : conditions;
                                    let newConditions = currentConditions.filter((item) => (item?.range && item?.timeFrame) || (item.fields && item.fields[0] !== 'unit_deviceModel_manufacturerId'));
                                    newConditions = newConditions.filter((item) => (item?.range && item?.timeFrame) || (item.fields && item.fields[0] !== 'unit_deviceModel_id'));
                                    if (manufacturer) {
                                        newConditions.push({ fields: ["unit_deviceModel_manufacturerId"], terms: [`${manufacturer.id}`], exact: true, conditionOperator: "AND" })
                                    }
                                    tableRef?.current?.getData({ newConditions });
                                    setConditions(newConditions);
                                }}
                                options={manufacturers || []}
                                textField="name"
                                valueField="id"
                                menuPlacement="auto"
                                isClearable={true}
                                loading={loadingManufactuers}
                                placeholder={messages['select']}
                            />
                        </div>
                    }
                </Grid>
                <Grid item xs={12} style={{ textAlign: 'left', marginTop: 10 }}>
                    {
                        HasPermission(user, "devmod") &&
                        <div>
                            <Select
                                id="deviceModels"
                                label={messages['devices_main_device_model']}
                                value={manufacturer && deviceModels && deviceModels.length > 0 && deviceModels.find(x => x.id === +deviceModel)}
                                onChange={(deviceModel) => {
                                    setDeviceModel(deviceModel ? deviceModel.id : null);
                                    let currentConditions = conditions.length === 0 ? tableRef?.current?.conditions : conditions;
                                    let newConditions = currentConditions.filter((item) => (item?.range && item?.timeFrame) || (item.fields && item.fields[0] !== 'unit_deviceModel_id'));
                                    
                                    if (deviceModel) {
                                        newConditions.push({ fields: ["unit_deviceModel_id"], terms: [`${deviceModel.id}`], exact: true, conditionOperator: "AND" })
                                    }
                                    tableRef?.current?.getData({ newConditions });
                                    setConditions(newConditions);
                                }}
                                options={manufacturer ? deviceModels && deviceModels.filter(x => x.manufacturerId === +manufacturer) : []}
                                textField="name"
                                valueField="id"
                                menuPlacement="auto"
                                isClearable={true}
                                loading={loadingDeviceModels}
                                placeholder={messages['select']}
                            />
                        </div>
                    }
                </Grid>
                <Grid item xs={12} style={{ textAlign: 'left', marginTop: 10 }}>
                    <div>
                        <Select
                            id="change-status-id"
                            valueField="id"
                            textField="label"
                            value={getStatusOptions(messages).find(x => x.id === +status)}
                            label={messages['account_change_status_label']}
                            placeholder={messages['account_change_status_label']}
                            options={getStatusOptions(messages) || []}
                            onChange={(status) => {
                                setStatus(status ? status.id : null);
                                let currentConditions = conditions.length === 0 ? tableRef?.current?.conditions : conditions;
                                let newConditions = currentConditions.filter((item) => (item?.range && item?.timeFrame) || (item.fields && item.fields[0] !== 'unit_status'));

                                if (status) {
                                    newConditions.push({ fields: ["unit_status"], terms: [`${status.id}`], exact: true, conditionOperator: "AND" })
                                }
                                tableRef?.current?.getData({ newConditions });
                                setConditions(newConditions);
                            }}
                            requiredMessage={messages['required_field']}
                        />
                    </div>
                </Grid>
            </Grid>
        </SidePanel>
    );
}
export default AdvancedFilters